import React, { useState } from 'react';

interface CompanyLogoBadgeProps {
  logoUrl?: string | null;
  companyName?: string | null;
  className?: string;
  altText?: string;
  variant?: 'dark-glass' | 'light-glass' | 'auto';
}

export const CompanyLogoBadge: React.FC<CompanyLogoBadgeProps> = ({
  logoUrl,
  companyName,
  className = '',
  altText = 'Company Logo',
  variant = 'dark-glass',
}) => {
  const [imageError, setImageError] = useState(false);

  // If no logoUrl or logo failed to load, display high quality initial typography badge
  if (!logoUrl || imageError) {
    const displayName = companyName || 'HiAcuity';
    const initial = displayName.charAt(0).toUpperCase();

    return (
      <div
        className={`inline-flex items-center gap-3 px-4 py-2.5 rounded-2xl bg-slate-900/95 border border-slate-700/80 shadow-xl backdrop-blur-md ${className}`}
      >
        <div className='w-8 h-8 rounded-xl bg-gradient-to-tr from-emerald-500 to-teal-400 flex items-center justify-center text-white font-bold text-lg shadow-sm'>
          {initial}
        </div>
        <span className='text-white font-semibold text-lg tracking-tight'>
          {displayName}
        </span>
      </div>
    );
  }

  // Universal Charcoal Glass container: Dark slate background ensures white text logos (e.g. Millennium IT ESP), 
  // dark logos, and bright logos are all 100% visible with optimal contrast.
  const containerStyle =
    variant === 'light-glass'
      ? 'bg-slate-900/95 border-slate-700/80 shadow-xl backdrop-blur-md'
      : 'bg-slate-900/95 border-slate-700/80 shadow-xl backdrop-blur-md';

  return (
    <div
      className={`inline-flex items-center justify-center max-w-[280px] min-w-[140px] min-h-[52px] px-5 py-2.5 rounded-2xl border transition-all duration-300 hover:scale-[1.01] ${containerStyle} ${className}`}
    >
      <img
        src={logoUrl}
        alt={altText}
        onError={() => setImageError(true)}
        className='max-h-10 w-auto max-w-full object-contain filter drop-shadow-[0_2px_6px_rgba(255,255,255,0.15)]'
      />
    </div>
  );
};

